
const BackToTop = () => {
    return (
        <div className="w-full flex items-center justify-center my-10">
            <button aria-label="backToTop" onClick={() => window.scrollTo(0, 0)} className="text-slate-800 font-bold scroll-smooth flex items-center gap-2 rounded-full uppercase">
                Back to top
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.9086 7.95289L11.9399 12.9841C12.2728 13.3541 12.2728 13.909 11.9399 14.242L11.089 15.0928C10.756 15.4258 10.1641 15.4258 9.83117 15.0928L6.2797 11.5044L2.69123 15.0928C2.35828 15.4258 1.80337 15.4258 1.43342 15.0928L0.619542 14.242C0.249597 13.909 0.249597 13.3541 0.619542 12.9841L5.65079 7.95289C5.98374 7.61994 6.53866 7.61994 6.9086 7.95289ZM5.65079 0.849953C5.98374 0.517003 6.53866 0.517003 6.9086 0.849953L11.9399 5.8812C12.2728 6.25115 12.2728 6.80607 11.9399 7.13902L11.089 7.98989C10.756 8.32284 10.1641 8.32284 9.83117 7.98989L6.2797 4.40142L2.69123 7.98989C2.35828 8.32284 1.80337 8.32284 1.43342 7.98989L0.619542 7.13902C0.249598 6.80607 0.249598 6.25115 0.619542 5.8812L5.65079 0.849953Z" fill="black" />
                </svg>

            </button>
        </div >
    )
}

export default BackToTop